import ms from "ms";
import HttpService from "services/HttpService";

import ENV from "../constants/ENV";

const ApiClientFrontLogs = new HttpService({
  baseURL: ENV.FLOG_ENDPOINT,
  defaultTimeout: ms(ENV.API_TIMEOUT_DURATION as ms.StringValue) / 2
});

ApiClientFrontLogs.addResponseInterceptor(
  "front-logs-response-interceptor",
  (response) => {
    const transformedResponse = Object.assign(
      {},
      {
        data: null
      },
      response.data
    );
    return transformedResponse;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default ApiClientFrontLogs;
